import React from 'react'
import 'raf/polyfill'
import 'babel-polyfill'
import axios from 'axios'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {getVipUser} from '../../redux/user.redux'
import {getUnReadNum} from '../../redux/chatuser.redux.js'
import {userList} from '../../redux/chatuser.redux.js'
import './third.css'
import HeaderBar from '../../component/header/header.js'
import { Link} from "react-router-dom"
import ToastBar from '../../component/toast/toast.js'
class ThirdLogin extends React.Component{
	constructor(props){
		super(props)
		this.state={
			imaskOff:false,
			gameId:''
		}

		
		
		
	}
	componentDidMount(){
	
		
	}

	componentWillReceiveProps(nextProps){

		if(this.props.userlist!=nextProps.userlist){
					//console.log(nextProps.userlist)
			if(nextProps.userlist.code==-1){
				
			}else{
				this.props.history.push('/third-info')
			}
		}
		
	}
	
	loginFn(isrc,iplat){
		
		axios.get('/fapi/'+isrc+'?plat='+iplat+'&&redirect_url='+encodeURIComponent(encodeURIComponent('/third-info')))
	      .then(res=>{
	       	if(res.data.return_code==0){
	       	
					window.location.href = res.data.redirect_url
				
				
		      
	       	}
	     
	    })
	}
	showMask(num){
		var igame = ''
		if(num===1){
			igame = '龙之谷'	
		}else{
			igame = '最终幻想'
		}
		this.setState({
    		imaskOff:true,
    		gameId:igame
    	})
	}
	closeMask(){
		this.setState({
    		imaskOff:false
    		
    	})
	}
	render(){
		return(
			<div className="third-login">

				<div className="third-list">
					<h6>盛趣游戏渠道登录</h6>
					<span>渠道用户请选择对应游戏进行登录</span>

				</div>
				<ul>
					<li onClick={()=>this.showMask(1)}><span className="span1"></span></li>
					{false &&<li onClick={()=>this.showMask(2)}><span className="span2"></span></li>}
				</ul>
			   {
			   	this.state.imaskOff&&<div className="third-mask"></div>
			   }
			   {
			   	this.state.imaskOff&&<div className="third-mask-con">
			   		<div>
			   			 <i onClick={()=>this.closeMask()}>×</i>
			   			<strong>{this.state.gameId}渠道登录</strong>

			   			<div className="div1" onClick={()=>this.loginFn('getLoginDNURL','wegame')}></div>
			   			{false&&<div className="div2"  onClick={()=>this.loginFn('getLoginDNSteamURL','')}></div>}
			   		</div>
			   </div>
			  }
			</div>
			
		)
	}
}
export default ThirdLogin


// WEBPACK FOOTER //
// ./src/container/third-login/third.js